/**
 * @generated SignedSource<<cdb676a392b548c91c3c6ecb4ca72d50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceVersionDeleteButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type WorkspaceVersionDeleteButtonMutation$data = {
  readonly deleteWorkspaceVersion: string;
};
export type WorkspaceVersionDeleteButtonMutation = {
  response: WorkspaceVersionDeleteButtonMutation$data;
  variables: WorkspaceVersionDeleteButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "deleteWorkspaceVersion",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceVersionDeleteButtonMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceVersionDeleteButtonMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteWorkspaceVersion",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "57cfc37c59accb0dfd996b751735df66",
    "id": null,
    "metadata": {},
    "name": "WorkspaceVersionDeleteButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceVersionDeleteButtonMutation(\n  $id: ID!\n) {\n  deleteWorkspaceVersion(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "fb61c1fd97f76c6af052311830b0e294";

export default node;
